import { trendingItems } from "@/mocks/home";

export default function TrendingSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              热门单品
            </h2>
            <p className="text-sm text-foreground-600">
              本周最受关注的潮流爆款
            </p>
          </div>
          <a
            href="/category"
            className="hidden md:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {trendingItems.map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer"
            >
              <div className="relative rounded-lg overflow-hidden aspect-[3/4] mb-3">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-full">
                    {item.category}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {item.name}
              </h3>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <a
            href="/category"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 cursor-pointer whitespace-nowrap"
          >
            查看全部热门单品
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>
      </div>
    </section>
  );
}